import React from 'react';
import { shape, string, arrayOf, func, number, bool } from 'prop-types';
import { Delivery1h, Delivery24h, DeliveryM, DeliveryRTomorrow, Pin, FastDelivery, PickupStore, ExpressDelivery } from '@magalu/stereo-ui-icons';
import { Container, DeliveryContainer, DeliveryItem, Label } from './delivery-filter.styles';

function DeliveryOption({
  item,
  onChange
}) {
  const {
    slug,
    label,
    selected
  } = item;

  const renderIcon = icon => {
    const Icons = {
      '24c': DeliveryRTomorrow,
      delivery_plus_1: FastDelivery,
      store_pickup: PickupStore,
      delivery_24h: Delivery24h,
      delivery_1h: Delivery1h,
      'magalu-entregas': DeliveryM,
      'magalu-partner': Pin,
      today: ExpressDelivery
    };
    const Icon = Icons[icon] || FastDelivery;
    return /*#__PURE__*/React.createElement(Icon, null);
  };

  return /*#__PURE__*/React.createElement(DeliveryItem, {
    onClick: () => onChange(!selected && slug || null),
    selected: selected,
    "data-testid": `opt-${slug}`
  }, renderIcon(slug), /*#__PURE__*/React.createElement(Label, {
    selected: selected
  }, label));
}

DeliveryOption.defaultProps = {
  item: {},
  onChange: null
};
process.env.NODE_ENV !== "production" ? DeliveryOption.propTypes = {
  item: shape({
    slug: string,
    label: string,
    count: number,
    selected: bool
  }),
  onChange: func
} : void 0;
/**
 * The `<DeliveryFilter />` component used to set filter based on delivery.
 */

function DeliveryFilter({
  data,
  onChange
}) {
  const {
    items
  } = data;

  function handleChange(value) {
    onChange(value && {
      type: 'delivery_magalu',
      value
    });
  }

  return /*#__PURE__*/React.createElement(Container, {
    carousel: (items == null ? void 0 : items.length) > 2
  }, /*#__PURE__*/React.createElement(DeliveryContainer, null, items == null ? void 0 : items.map((item, index) => /*#__PURE__*/React.createElement(DeliveryOption, {
    "data-testid": "filter-option",
    key: `filter-option-${item.slug}-${index}`,
    onChange: handleChange,
    item: item
  }))));
}

DeliveryFilter.defaultProps = {
  onChange: null
};
process.env.NODE_ENV !== "production" ? DeliveryFilter.propTypes = {
  data: shape({
    title: string,
    items: arrayOf(shape({
      slug: string,
      label: string,
      count: number,
      selected: bool
    }))
  }).isRequired,
  onChange: func
} : void 0;
export default DeliveryFilter;